import { render } from "./EcomConfig.vue?vue&type=template&id=0992628d&scoped=true"
import script from "./EcomConfig.vue?vue&type=script&lang=js"
export * from "./EcomConfig.vue?vue&type=script&lang=js"

import "./EcomConfig.vue?vue&type=style&index=0&id=0992628d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0992628d"]])

export default __exports__